import isEmpty from "lodash-es/isEmpty";
const getAggsItems = (id, items) => {
    if (isEmpty(items))
        return items;
    const keySort = `${id}weight`;
    // if has keySort, need to sort
    const aggsItems = !items[0][keySort]
        ? items
        : items.sort((a, b) => {
            try {
                const aKey = a[keySort].buckets[0].key;
                const bKey = b[keySort].buckets[0].key;
                if (aKey > bKey)
                    return 1;
                if (aKey < bKey)
                    return -1;
                return 0;
            }
            catch {
                return 0;
            }
        });
    return aggsItems.map(({ key, doc_count }) => ({ key, doc_count }));
};
export default getAggsItems;
